var React = require('react');

function KpiIcon10 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M54.2,35.79A26.31,26.31,0,1,1,27.9,9.48","transform":"translate(-0.16 -0.35)","fill":"none","stroke":"#23282c","strokeWidth":"2.85","key":0}),React.createElement("path",{"d":"M61.4,30.3S62.91,4.68,33.51,1.91V30.25Z","transform":"translate(-0.16 -0.35)","fill":"none","stroke":"#fc5a10","strokeLinecap":"round","strokeWidth":"2.85","key":1})]);
}

KpiIcon10.defaultProps = {"width":"22.11mm","height":"22.28mm","viewBox":"0 0 62.67 63.17"};

module.exports = KpiIcon10;

KpiIcon10.default = KpiIcon10;
